/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 30/07/13
 * Time: 10:58
 * To change this template use File | Settings | File Templates.
 */


angular.module('FlexyBeautyApp.services').factory('MobileDevice_Resource', ["$resource", "$location", function ($resource, $location) {
    var baseUrl = $location.protocol() + "://" + $location.host() + ($location.port() && ":" + $location.port()) + "/";
    var resourceBooking = $resource(baseUrl + 'rest/mobileDevices/:id', {}, {
        query: {method: 'GET', isArray: true},
        get: {method: 'GET'},
        setCustomer: {method: 'POST', url: baseUrl + 'rest/mobileDevices/setCustomer'}
    });
    return resourceBooking;
}
]);

angular.module('FlexyBeautyApp.services').factory('MobileDevice', ["MobileDevice_Resource", "MobileDeviceData", function (MobileDevice_Resource, MobileDeviceData) {
    var MobileDevice = function (resource) {
        this.id = null;
        this.isDeleted = false;
        this.os = null;
        this.osVersion = null;
        this.token = null;
        this.customerId = null;
        this.lastAppOpening = null;
        this.loadObject(resource);
        MobileDeviceData.add(this);
    }
    MobileDevice.prototype.loadObject = function (object) {
        if (object !== undefined && object != null) {
            if (!this.id)
                this.id = object.id;
            this.isDeleted = object.isDeleted;
            this.os = object.os;
            this.osVersion = object.osVersion;
            this.token = object.token;
            if (object.customerId)
                this.customerId = object.customerId;
            this.lastAppOpening = object.lastAppOpening;

        }
    }
    MobileDevice.prototype.getObjectResource = function () {
        var rsMobileDevice = new MobileDevice_Resource();
        rsMobileDevice.id = this.id;
        rsMobileDevice.isDeleted = this.isDeleted;
        rsMobileDevice.os = this.os;
        rsMobileDevice.osVersion = this.osVersion;
        rsMobileDevice.token = this.token;
        rsMobileDevice.customerId = this.customerId;
        rsMobileDevice.lastAppOpening = this.lastAppOpening;
        return rsMobileDevice;
    }

    MobileDevice.prototype.getId = function () {
        return this.id;
    }

    MobileDevice.prototype.setId = function (id) {
        this.id = id;
    }

    return MobileDevice;
}
]);


angular.module('FlexyBeautyApp.services').factory('MobileDeviceSrv', ["$log", "MobileDevice_Resource", "ServerSrv", "MobileDeviceData", "MobileDevice",
    function ($log, MobileDevice_Resource, ServerSrv, MobileDeviceData, MobileDevice) {
        var mobileDeviceSrv = {};

        mobileDeviceSrv.setCustomer = function (mobileDevice, customerId, successFunction, errorFunction) {
            ServerSrv.startSavingProcess(mobileDeviceSrv.setCustomerSync, mobileDevice, customerId, successFunction, errorFunction);
        };
        mobileDeviceSrv.setCustomerSync = function (mobileDevice, customerId, successFunction, errorFunction) {
            var mobileDeviceRes = new MobileDevice_Resource();
            mobileDeviceRes.os = mobileDevice.os;
            mobileDeviceRes.osVersion = mobileDevice.osVersion;
            mobileDeviceRes.token = mobileDevice.token;
            mobileDeviceRes.customerId = customerId;
            mobileDeviceRes.setCustomer({}, //no params
                function (data) {
                    try {
                        if (successFunction != undefined)
                            successFunction(data);
                    } finally {
                        ServerSrv.endSavingProcess(true);
                    }
                },
                function (data) {   //failure
                    //error handling goes here
                    try {
                        if (errorFunction != undefined)
                            errorFunction(data);
                    } finally {
                        ServerSrv.endSavingProcess(false, (data ? data.status : null), (data && data.data ? data.data.errorCode : null));
                    }
                }
            );

            //},2000)
        };

        mobileDeviceSrv.query = function (successFunction, errorFunction) {
            MobileDevice_Resource.query(
                {}, //params
                function (data) {   //success
                    MobileDeviceData.clear();
                    for (var i = 0; i < data.length; i++)
                        new MobileDevice(data[i]);//Auto Add to MobileDeviceData
                    if (successFunction !== undefined)
                        successFunction(MobileDeviceData.indexMobileDevice);

                },
                function (data) {   //failure
                    $log.error("MobileDevice_Resource.query error");
                    $log.error(data);
                    if (errorFunction !== undefined)
                        errorFunction(data);
                });
        };


        mobileDeviceSrv.get = function (id, successFunction, errorFunction) {
            MobileDevice_Resource.get(
                {id: id}, //params
                function (mobileDeviceResource) {
                    if (successFunction != undefined)
                        successFunction(new MobileDevice(mobileDeviceResource));
                },
                function (data) {
                    if (errorFunction != undefined)
                        errorFunction(data);
                });
        };
        return mobileDeviceSrv;
    }
]);
angular.module('FlexyBeautyApp.services').factory('MobileDeviceData', ["$filter", function ($filter) {
    var mobileDeviceDataSrv =
        {
            indexMobileDevice: [],
            activeMobileDevice: [],
            deletedMobileDevices: []//deleted items
        };
    mobileDeviceDataSrv.getById = function (mobileDeviceId) {
        for (var i = 0; i < this.indexMobileDevice.length; i++)
            if (this.indexMobileDevice[i].getId() == mobileDeviceId)
                return this.indexMobileDevice[i];
        return null;
    }

    //return all mobiles for a customer. The more recent device is the first element in the tab.
    mobileDeviceDataSrv.getListByCustomerId = function (customerId) {
        var tabDevices = [];
        for (var i = 0; i < this.activeMobileDevice.length; i++) {
            if (this.activeMobileDevice[i].customerId == customerId)
                tabDevices.push(this.activeMobileDevice[i]);
        }
        if (tabDevices.length == 0)
            return null;
        tabDevices.sort(function (a, b) {
            if (a.lastAppOpening > b.lastAppOpening)
                return -1;
            if (a.lastAppOpening < b.lastAppOpening)
                return 1;
            if (a.lastAppOpening == b.lastAppOpening)
                return 0;
        });
        return tabDevices;
    }


    mobileDeviceDataSrv.getByIndex = function (index) {
        if (index >= 0 && index < this.indexMobileDevice.length)
            return this.indexMobileDevice[index];
        return null;
    }
    mobileDeviceDataSrv.getIndexOf = function (mobileDevice) {
        if (mobileDevice)
            return this.indexMobileDevice.indexOf(mobileDevice);
        return -1;
    }

    mobileDeviceDataSrv.add = function (mobileDevice) {
        var mobileDeviceArray = this.activeMobileDevice;
        if (mobileDevice.isDeleted)
            mobileDeviceArray = this.deletedMobileDevice;
        var index = this.indexMobileDevice.indexOf(mobileDevice);
        if (index != -1) {
            var realIndex = mobileDeviceArray.indexOf(mobileDevice);
            if (realIndex == -1)
                mobileDeviceArray.push(mobileDevice);
        } else {
            index = this.indexMobileDevice.length
            this.indexMobileDevice.push(mobileDevice);
            mobileDeviceArray.push(mobileDevice);
        }
        return index;
    }
    mobileDeviceDataSrv.remove = function (mobileDevice) {
        var index = this.activeMobileDevice.indexOf(mobileDevice);
        if (index != -1) {
            this.activeMobileDevice.splice(index, 1);
            this.deletedMobileDevice.push(mobileDevice)
            mobileDevice.isDeleted = true;
        }
    }
    mobileDeviceDataSrv.restore = function (mobileDevice) {
        var index = this.deletedMobileDevice.indexOf(mobileDevice);
        if (index != -1) {
            this.deletedMobileDevice.splice(index, 1);
            this.activeMobileDevice.push(mobileDevice);
            mobileDevice.isDeleted = false;
        }
    }
    mobileDeviceDataSrv.clear = function () {
        this.indexMobileDevice = [];
        this.activeMobileDevice = [];
        this.deletedMobileDevice = [];
    }

    mobileDeviceDataSrv.getActiveList = function () {
        return this.activeMobileDevice;
    }
    mobileDeviceDataSrv.getDeletedList = function () {
        return this.deletedMobileDevice;
    }
    return mobileDeviceDataSrv;
}
]);



// WEBPACK FOOTER //
// ./js/services/models/MobileDevice.js